import gsap from 'gsap'
import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    this.btn = document.querySelector('.c-header__leap')
    this.leap = document.querySelector('.c-leap')
    this.content = document.querySelector('.c-leap__content p')
    this.setTimeline()
  }

  setTimeline () {
    const targets = gsap.utils.toArray(
      '.c-leap .whitespace, .c-leap .char, .c-leap strong'
    )

    gsap.set(targets, { autoAlpha: 0 })

    this.tl = gsap.timeline({
      paused: true,
      repeat: -1,
      repeatDelay: 2
    })

    targets.forEach(target => {
      this.tl.to(target, {
        autoAlpha: 1,
        duration: gsap.utils.random(0, 0.1, 0.025)
      })
    })

    this.tl.to(this.content, { autoAlpha: 0, duration: 1 })

    this.btn.addEventListener('mouseenter', () => {
      gsap.to('.c-leap', { autoAlpha: 1 })
      this.tl.play()
    })

    this.btn.addEventListener('mouseleave', () => {
      this.tl.pause()
      gsap.killTweensOf('.c-leap')
      gsap.to('.c-leap', { autoAlpha: 0 })
    })
  }
}
